// https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#Polyfill
(function() {
  if (typeof window.CustomEvent === 'function') {
    return false;
  }
  function CustomEvent(event, params) {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  }

  CustomEvent.prototype = window.Event.prototype;

  window.CustomEvent = CustomEvent;
})();
(function(modules) { // webpackBootstrap
//The module cache
  var installedModules = {};
  //The require function
  function __webpack_require__(moduleId) {
  //Check if module is in cache
    if (installedModules[moduleId]) {
      return installedModules[moduleId].exports;
    }
    /******/
    // Create a new module (and put it into the cache)
    var module = installedModules[moduleId] = {
      exports: {},
      id: moduleId,
      loaded: false
    };
    /******/
    // Execute the module function
    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/
    // Flag the module as loaded
    module.loaded = true;
    /******/
    // Return the exports of the module
    return module.exports;
  }/******/
  // expose the modules object (__webpack_modules__)
  __webpack_require__.m = modules;
  /******/
  // expose the module cache
  __webpack_require__.c = installedModules;
  /******/
  // __webpack_public_path__
  __webpack_require__.p = '';
  /******/
  // Load entry module and return exports
  return __webpack_require__(0);
})
/************************************************************************/

/* 0 */
/*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/
/***/
([function(module, exports, __webpack_require__) {
  'use strict';
  // Style
  __webpack_require__(/*! ./index.scss */ 1);

  var bindComparison = function bindComparison(handle, resized, container) {
    var moveWidth = 0;
    var imageContainer = container.querySelector('.slide-comparison__img');
    var scrollBlock = function scrollBlock(e) {
      e.preventDefault();
    };

    var unbindScrollBlock = function unbindScrollBlock(e) {
      document.removeEventListener('touchmove', scrollBlock);
    };

    var getPageY = function getPageY(e) {
      if (e.pageY || (e.targetTouches && e.targetTouches[0].pageY)) {
        return e.pageY || e.targetTouches[0].pageY;
      } else if (typeof e.originalEvent !== 'undefined') {
        return e.originalEvent.targetTouches[0].pageY;
      } else {
        return false;
      }
    };

    var getPageX = function getPageX(e) {
      if (e.pageX || (e.targetTouches && e.targetTouches[0].pageX)) {
        return e.pageX || e.targetTouches[0].pageX;
      } else if (typeof e.originalEvent !== 'undefined') {
        return e.originalEvent.targetTouches[0].pageX;
      } else {
        return false;
      }
    };

    var hasClass = function(element, cls) {
      return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
    };

    var moveSlide = function(e) {
      var moveWidthDecimal = e.detail.left;
      var moveWidth = moveWidthDecimal * 100 + '%';
      handle.style.left = moveWidth;
      resized.style.width = moveWidth;
    };

    var handleMove = function(e) {
      if (hasClass(container, 'disable-mouseover')) {
        return;
      }
      document.addEventListener('touchmove', scrollBlock, false);

      var pageX = getPageX(e);
      if (pageX === false) {
        return;
      }
      var pageY = getPageY(e);
      if (pageY === false) {
        return;
      }
      var rect = imageContainer.getBoundingClientRect();
      var scrollY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

      // contrainer mousemove handling to within height box of images
      if (pageY < (rect.top + scrollY)) {
        return;
      }
      if (pageY > (rect.bottom + scrollY)) {
        return;
      }

      var moveWidthDecimal = (pageX - rect.left - 1) / imageContainer.offsetWidth;
      if (moveWidthDecimal <= 0) {
        // this can't be 0 cuz the divider will glitch out.
        // we need some width
        moveWidthDecimal = 0.01;
      }
      if (moveWidthDecimal > 1) {
        moveWidthDecimal = 1;
      }
      var event = new CustomEvent('moveSlide', { detail: {left: moveWidthDecimal }});
      container.dispatchEvent(event);
    };

    // Bind events to container
    container.addEventListener('mousemove', handleMove);
    container.addEventListener('touchmove', handleMove);
    container.addEventListener('touchend', unbindScrollBlock);

    container.addEventListener('moveSlide', moveSlide);
  };

  window.imageComparisonSliderResizeImages = function() {
    var sliders = Array.prototype.slice.call(document.querySelectorAll('.slide-comparison'), 0);
    sliders.forEach(function(element, index, array) {
      var imageContainer = element.querySelector('.slide-comparison__img');
      console.log(imageContainer.offsetWidth);
      element.querySelector('.resized img').style.width = imageContainer.offsetWidth + 'px';
    });
  };

  // Get sliders and iterate on them
  window.imageComparisonSliderAttach = function(sliders) {
    window.imageComparisonSliderResizeImages();
    sliders.forEach(function(element, index, array) {
      bindComparison(element.querySelector('.divider'), element.querySelector('.resized'), element);
    });
  };

  // On window resize
  window.onresize = function(event) {
    window.imageComparisonSliderResizeImages();
  };

  // run once here so it runs early.
  window.imageComparisonSliderResizeImages();
  /***/ },
/* 1 */
/*!************************!*\
  !*** ./src/index.scss ***!
  \************************/
/***/ function(module, exports, __webpack_require__) {
  // style-loader: Adds some css to the DOM by adding a <style> tag

  // load the styles
  var content = __webpack_require__(/*! !./../~/css-loader!./../~/sass-loader!./index.scss */ 2);
  if (typeof content === 'string') {
    content = [[module.id, content, '']];
  }
  // add the styles to the DOM
  var update = __webpack_require__(/*! ./../~/style-loader/addStyles.js */ 4)(content, {});
  if (content.locals) {
    module.exports = content.locals;
  }
  // Hot Module Replacement
  if (false) {
    // When the styles change, update the <style> tags
    if (!content.locals) {
      module.hot.accept('!!./../node_modules/css-loader/index.js!./../node_modules/sass-loader/index.js!./index.scss', function() {
        var newContent = require('!!./../node_modules/css-loader/index.js!./../node_modules/sass-loader/index.js!./index.scss');
        if (typeof newContent === 'string') {
          newContent = [[module.id, newContent, '']];
        }
        update(newContent);
      });
    }
    // When the module is disposed, remove the <style> tags
    module.hot.dispose(function() {
      update();
    });
  }
  /***/ },
/* 2 */
/*!*******************************************************!*\
  !*** ./~/css-loader!./~/sass-loader!./src/index.scss ***!
  \*******************************************************/
/***/ function(module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(/*! ./../~/css-loader/lib/css-base.js */ 3)();
  // imports

  // module
  exports.push([module.id, '.slide-comparison__img{width:500px;height:500px;position:relative;overflow:hidden}.slide-comparison__img img{display:block;width:100%;height:100%}.slide-comparison__img .resized{position:absolute;top:0;left:0;height:100%;width:50%;overflow:hidden}.slide-comparison__img .divider{position:absolute;left:50%;top:0;bottom:0;width:4px;margin-left:-2px;background:rgba(0,0,0,.5)}@media (max-width:767px){.slide-comparison__img{width:330px;height:330px}}@media only screen and (min-device-width : 768px) and (max-device-width : 1024px){.slide-comparison__img{width:380px;height:380px}}', '']);

  // exports
  /***/ },
/* 3 */
/*!**************************************!*\
  !*** ./~/css-loader/lib/css-base.js ***!
  \**************************************/
/***/ function(module, exports) {
  /*
    MIT License http://www.opensource.org/licenses/mit-license.php
    Author Tobias Koppers @sokra
    */
  // css base code, injected by the css-loader
  module.exports = function() {
    var list = [];

    // return the list of modules as css string
    list.toString = function toString() {
      var result = [];
      for (var i = 0; i < this.length; i++) {
        var item = this[i];
        if (item[2]) {
          result.push('@media ' + item[2] + '{' + item[1] + '}');
        } else {
          result.push(item[1]);
        }
      }
      return result.join('');
    };

    // import a list of modules into the list
    list.i = function(modules, mediaQuery) {
      if (typeof modules === 'string') {
        modules = [[null, modules, '']];
      }
      var alreadyImportedModules = {};
      for (let i = 0; i < this.length; i++) {
        var id = this[i][0];
        if (typeof id === 'number') {
          alreadyImportedModules[id] = true;
        }
      }
      for (var i = 0; i < modules.length; i++) {
        var item = modules[i];
        // skip already imported module
        // this implementation is not 100% perfect for weird media query combinations
        //when a module is imported multiple times with different media queries.
        //I hope this will never occur (Hey this way we have smaller bundles)
        if (typeof item[0] !== 'number' || !alreadyImportedModules[item[0]]) {
          if (mediaQuery && !item[2]) {
            item[2] = mediaQuery;
          } else if (mediaQuery) {
            item[2] = '(' + item[2] + ') and (' + mediaQuery + ')';
          }
          list.push(item);
        }
      }
    };
    return list;
  };
  /***/ },
/* 4 */
/*!*************************************!*\
  !*** ./~/style-loader/addStyles.js ***!
  \*************************************/
/***/ function(module, exports, __webpack_require__) {
  /*
    MIT License http://www.opensource.org/licenses/mit-license.php
    Author Tobias Koppers @sokra
    */
  var stylesInDom = {},
      memoize = function(fn) {
        var memo;
        return function() {
          if (typeof memo === 'undefined') {
            memo = fn.apply(this, arguments);
          }
          return memo;
        };
      },
      isOldIE = memoize(function() {
        return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
      }),
      getHeadElement = memoize(function() {
        return document.head || document.getElementsByTagName('head')[0];
      }),
      singletonElement = null,
      singletonCounter = 0,
      styleElementsInsertedAtTop = [];

  module.exports = function(list, options) {
    if (true) {
      if (typeof document !== 'object') {
        throw new Error('The style-loader cannot be used in a non-browser environment');
      }
    }

    options = options || {};
    // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
    // tags it will allow on a page
    if (typeof options.singleton === 'undefined') {
      options.singleton = isOldIE();
    }

    // By default, add <style> tags to the bottom of <head>.
    if (typeof options.insertAt === 'undefined') {
      options.insertAt = 'bottom';
    }

    var styles = listToStyles(list);
    addStylesToDom(styles, options);

    return function update(newList) {
      var mayRemove = [];
      for (let i = 0; i < styles.length; i++) {
        var item = styles[i];
        domStyle = stylesInDom[item.id];
        domStyle.refs--;
        mayRemove.push(domStyle);
      }
      if (newList) {
        var newStyles = listToStyles(newList);
        addStylesToDom(newStyles, options);
      }
      for (var i = 0; i < mayRemove.length; i++) {
        var domStyle = mayRemove[i];
        if (domStyle.refs === 0) {
          for (var j = 0; j < domStyle.parts.length; j++) {
            domStyle.parts[j]();
          }
          delete stylesInDom[domStyle.id];
        }
      }
    };
  };

  function addStylesToDom(styles, options) {
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i];
      var domStyle = stylesInDom[item.id];
      if (domStyle) {
        domStyle.refs++;
        for (let j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j](item.parts[j]);
        }
        for (; j < item.parts.length; j++) {
          domStyle.parts.push(addStyle(item.parts[j], options));
        }
      } else {
        var parts = [];
        for (var j = 0; j < item.parts.length; j++) {
          parts.push(addStyle(item.parts[j], options));
        }
        stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
      }
    }
  }

  function listToStyles(list) {
    var styles = [];
    var newStyles = {};
    for (var i = 0; i < list.length; i++) {
      var item = list[i];
      var id = item[0];
      var css = item[1];
      var media = item[2];
      var sourceMap = item[3];
      var part = {css: css, media: media, sourceMap: sourceMap};
      if (!newStyles[id]) {
        styles.push(newStyles[id] = {id: id, parts: [part]});
      } else {
        newStyles[id].parts.push(part);
      }
    }
    return styles;
  }

  function insertStyleElement(options, styleElement) {
    var head = getHeadElement();
    var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
    if (options.insertAt === 'top') {
      if (!lastStyleElementInsertedAtTop) {
        head.insertBefore(styleElement, head.firstChild);
      } else if (lastStyleElementInsertedAtTop.nextSibling) {
        head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
      } else {
        head.appendChild(styleElement);
      }
      styleElementsInsertedAtTop.push(styleElement);
    } else if (options.insertAt === 'bottom') {
      head.appendChild(styleElement);
    } else {
      throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
    }
  }

  function removeStyleElement(styleElement) {
    styleElement.parentNode.removeChild(styleElement);
    var idx = styleElementsInsertedAtTop.indexOf(styleElement);
    if (idx >= 0) {
      styleElementsInsertedAtTop.splice(idx, 1);
    }
  }

  function createStyleElement(options) {
    var styleElement = document.createElement('style');
    styleElement.type = 'text/css';
    insertStyleElement(options, styleElement);
    return styleElement;
  }

  function createLinkElement(options) {
    var linkElement = document.createElement('link');
    linkElement.rel = 'stylesheet';
    insertStyleElement(options, linkElement);
    return linkElement;
  }

  function addStyle(obj, options) {
    var styleElement, update, remove;

    if (options.singleton) {
      var styleIndex = singletonCounter++;
      styleElement = singletonElement || (singletonElement = createStyleElement(options));
      update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
      remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
    } else if (obj.sourceMap &&
        typeof URL === 'function' &&
        typeof URL.createObjectURL === 'function' &&
        typeof URL.revokeObjectURL === 'function' &&
        typeof Blob === 'function' &&
        typeof btoa === 'function') {
      styleElement = createLinkElement(options);
      update = updateLink.bind(null, styleElement);
      remove = function() {
        removeStyleElement(styleElement);
        if (styleElement.href) {
          URL.revokeObjectURL(styleElement.href);
        }
      };
    } else {
      styleElement = createStyleElement(options);
      update = applyToTag.bind(null, styleElement);
      remove = function() {
        removeStyleElement(styleElement);
      };
    }

    update(obj);

    return function updateStyle(newObj) {
      if (newObj) {
        if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
          return;
        }
        update(obj = newObj);
      } else {
        remove();
      }
    };
  }

  var replaceText = (function() {
    var textStore = [];

    return function(index, replacement) {
      textStore[index] = replacement;
      return textStore.filter(Boolean).join('\n');
    };
  })();

  function applyToSingletonTag(styleElement, index, remove, obj) {
    var css = remove ? '' : obj.css;

    if (styleElement.styleSheet) {
      styleElement.styleSheet.cssText = replaceText(index, css);
    } else {
      var cssNode = document.createTextNode(css);
      var childNodes = styleElement.childNodes;
      if (childNodes[index]) {
        styleElement.removeChild(childNodes[index]);
      }
      if (childNodes.length) {
        styleElement.insertBefore(cssNode, childNodes[index]);
      } else {
        styleElement.appendChild(cssNode);
      }
    }
  }

  function applyToTag(styleElement, obj) {
    var css = obj.css;
    var media = obj.media;

    if (media) {
      styleElement.setAttribute('media', media);
    }

    if (styleElement.styleSheet) {
      styleElement.styleSheet.cssText = css;
    } else {
      while (styleElement.firstChild) {
        styleElement.removeChild(styleElement.firstChild);
      }
      styleElement.appendChild(document.createTextNode(css));
    }
  }

  function updateLink(linkElement, obj) {
    var css = obj.css;
    var sourceMap = obj.sourceMap;

    if (sourceMap) {
      // http://stackoverflow.com/a/26603875
      css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */';
    }

    var blob = new Blob([css], { type: 'text/css' });

    var oldSrc = linkElement.href;

    linkElement.href = URL.createObjectURL(blob);

    if (oldSrc) {
      URL.revokeObjectURL(oldSrc);
    }
  }
}
]);
//# sourceMappingURL=image-comparison-slider.js.map
